import React from 'react';

function Logo(props) {
  return (
    <img
      alt="Logo"
      src="/example-logo.png"
      {...props}
    />
  );
}

export default Logo;
